import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import authReducer from "../redux/slices/authSlice";
import userInfoStepperReducer from "../redux/slices/userInfoStepperSlice";
import generalReducer from "../redux/slices/generalSlice";
import profileReducer from "./slices/profileSlice";
import certificateStatusReducer from "./slices/certificateStatusSlice";
import atpReducer from "./slices/atpSlice";
import paymentSlice from "./slices/paymentSlice";

const authPersistConfig = {
  key: "auth",
  version: 1,
  storage,
  whitelist: ["user", "isUserVerified", "active", "percent_calc"],
};

const certificateStatusPersistConfig = {
  key: "certificateStatus",
  version: 1,
  storage,
  whitelist: ["data"],
};

const persistedReducer = persistReducer(authPersistConfig, authReducer);
const certificateStatuspersistedReducer = persistReducer(
  certificateStatusPersistConfig,
  certificateStatusReducer
);

export const store = configureStore({
  reducer: {
    auth: persistedReducer,
    userInfoStepper: userInfoStepperReducer,
    general: generalReducer,
    profile: profileReducer,
    certificateStatus: certificateStatuspersistedReducer,
    atp: atpReducer,
    payment: paymentSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
